const referFriend = {
  INDEX: '/refer-friend',
}

export default referFriend
